<template>
  <div class="flat-choice flex flex-col h-full">
      <h1 class="text title _x-bold flat-choice__title mobile-only"
          :class="{'_options-open':showParams}"
      >Выбор квартиры</h1>
      <div class="mobile-only flex flex-col h-full" :class="{'bg-white':!showParams}">
        <transition name="component-fade" mode="out-in" v-if="!showParams">
          <div class="flat-choice__image flat-choice-image">
            <div class="flat-choice-image__pic">
              <picture>
                <source type="image/webp" srcset="/images/purchase/district-mobile.webp 1x, /images/purchase/district-mobile2x.webp 2x">
                <img src="/images/purchase/district-mobile.png" srcset="/images/purchase/district-mobile2x.png 2x" alt="">
              </picture>
            </div>
            <img class="flat-choice-image__mask"
                 src="/images/purchase/building-mask-mobile.png"
                 v-if="selectedBuilding === 2"
            >
          </div>
        </transition>
        <button
          class="flat-choice__choose flat-choose flex items-center justify-center mt-auto"
          @click="openParams"
          v-if="!showParams"
        >
          <span class="flat-choose__text">Выбрать квартиру</span>
          <svg class="flat-choose__icon" v-if="!showParams">
            <use xlink:href="../../../images/sprite.svg#plus"/>
          </svg>
          <svg class="flat-choose__icon _minus" v-if="showParams">
            <use xlink:href="../../../images/sprite.svg#minus"/>
          </svg>
        </button>
        <transition name="component-fade" mode="out-in">
          <form class="flat-choice__params flat-params" v-if="showParams && filteredApartments && !showLoader">
            <p class="text mb-2">Выберите квартиру по параметрам:</p>
            <Picker
              heading="Корпуса жилые"
              :options="buildingOptions"
              :selected="selectedBuilding"
              @selectOption="selectBuilding"
              class="flat-params__row"
            />
            <Picker
              heading="Количество комнат"
              :options="roomOptions"
              @selectOption="selectRooms"
              :selected="selectedRooms"
              class="flat-params__row"
            />
            <Slider
              heading="Этажность"
              heading-margin-bottom="3rem"
              :value="floor"
              :min="limitsFloor[0]"
              :max="limitsFloor[1]"
              @changeValue="changeFloorValue"
              class="flat-params__row"
              v-if="filteredApartments && !showLoader"
            />
            <Slider
              :heading="areaHeading"
              heading-margin-bottom="3rem"
              :value="area"
              :min="limitsArea[0]"
              :max="limitsArea[1]"
              @changeValue="changeAreaValue"
              class="flat-params__row"
              v-if="filteredApartments && !showLoader"
            />
            <Slider
              heading="Стоимость (млн)"
              heading-margin-bottom="3rem"
              :value="price"
              :min="limitsPrice[0]"
              :max="limitsPrice[1]"
              @changeValue="changePriceValue"
              v-if="filteredApartments && !showLoader"
            />
          </form>
        </transition>
        <button class="flat-choice__show"
                v-if="showParams"
                @click="showFlats"
                :class="{'_options-open':showParams}"
        >Смотреть</button>
        <div
          v-if="showParams && flatOptionsShown"
          class="flat-choice__options flat-options"
          :class="{'_options-open':showParams}"
        >
          <div class="flex items-center flat-options__heading flat-options-heading">
            <span class="flat-options-heading__text" v-bind:class="{desc: orderBy === 'building_number' && sortOrder === 'desc', asc: orderBy === 'building_number' && sortOrder === 'asc' }" @click="sortBy('building_number')">Корпус</span>
            <span class="flat-options-heading__text" v-bind:class="{desc: orderBy === 'floor_number' && sortOrder === 'desc', asc: orderBy === 'floor_number' && sortOrder === 'asc' }" @click="sortBy('floor_number')">Этаж</span>
            <span class="flat-options-heading__text" v-bind:class="{desc: orderBy === 'bedrooms'  && sortOrder === 'desc', asc: orderBy === 'bedrooms'  && sortOrder === 'asc' }" @click="sortBy('bedrooms')">Комнаты</span>
            <span class="flat-options-heading__text" v-bind:class="{desc: orderBy === 'area'  && sortOrder === 'desc', asc: orderBy === 'area'  && sortOrder === 'asc' }" @click="sortBy('area')">Площадь</span>
            <span class="flat-options-heading__text" v-bind:class="{desc: orderBy === 'price'  && sortOrder === 'desc', asc: orderBy === 'price'  && sortOrder === 'asc' }" @click="sortBy('price')">Стоимость</span>
            <span class="flat-options-heading__text _uppercase _fw-800 _invisible" style="padding-left:5rem">
                <svg class="flat-choose__icon _arrow">
                    <use xlink:href="../../../images/sprite.svg#flat-arrow"/>
                </svg>
            </span>
          </div>
          <router-link tag="div" :to="'/choice-of-apartment/selected/' + flat.id"
                       class="flex items-end flat-options__row flat-options-row" v-for="flat in filteredApartments"
                       :key="flat.id">
            <span class="flat-options-row__text _building">{{flat.building_number}}</span>
            <span class="flat-options-row__text _floor">{{flat.floor_number}}</span>
            <span class="flat-options-row__text _rooms">{{flat.bedrooms}}</span>
            <span class="flat-options-row__text _area">{{flat.area}} м<sup>2</sup></span>
            <span class="flat-options-row__text _price">{{flat.price.toString().indexOf('.') > -1 ? flat.price.split('.')[0] : flat.price}} руб.</span>
<!--            <span class="flat-options-row__text _special" v-if="flat.special">акция</span>-->
<!--            <span class="flat-options-row__text _special" v-if="!flat.special"></span>-->
            <span class="flat-options-row__text _arrow">
                <svg class="flat-choose__icon _arrow">
                    <use xlink:href="../../../images/sprite.svg#flat-arrow"/>
                </svg>
            </span>
          </router-link>
        </div>
        <router-link
          tag="button"
          to='/choice-of-apartment/details'
          class="flat-choice__plan cursor-pointer flex items-center justify-center"
          :class="{'_options-open':showParams}"
        >
          <span>Выбрать по генплану</span>
          <svg class="flat-choose__icon _arrow _white ml-1" v-if="showParams">
            <use xlink:href="../../../images/sprite.svg#flat-arrow-white"/>
          </svg>
        </router-link>
      </div>
      <div class="desktop-only flat-choice__bg-desktop relative">
        <form class="flat-choice__params flat-params">
          <div class="flat-params__wrapper js-flats-wrapper" v-scroll="attachHeader">
            <h1 class="text title _x-bold flat-params__title">Выбор квартиры</h1>
            <router-link
              tag="button"
              to='/choice-of-apartment/details'
              class="flat-params__subtitle cursor-pointer flex items-center justify-center brown-btn"
            >
              <span>Выбрать по генплану</span>
              <svg class="flat-choose__icon _arrow _white ml-1">
                <use xlink:href="../../../images/sprite.svg#flat-arrow-white"/>
              </svg>
            </router-link>
            <div class="flex">
              <div class="flex flex-col flat-params__pickers">
                <Picker
                  heading="Корпуса жилые"
                  :options="buildingOptions"
                  :selected="selectedBuilding"
                   @selectOption="selectBuilding"
                  class="flat-params__picker"
                />
                <Picker
                  heading="Количество комнат"
                  :options="roomOptions"
                  @selectOption="selectRooms"
                  :selected="selectedRooms"
                  class="flat-params__picker"
                />
              </div>
              <div class="flex flex-col flat-params__sliders" v-if="filteredApartments && !showLoader">
                <Slider
                  heading="Этажность"
                  heading-margin-bottom="1rem"
                  :is-desktop="true"
                  :value="floor"
                  :min="limitsFloor[0]"
                  :max="limitsFloor[1]"
                  @changeValue="changeFloorValue"
                  class="flat-params__slider"
                  v-if="filteredApartments && !showLoader"
                />
                <Slider
                  :heading="areaHeading"
                  heading-margin-bottom="1rem"
                  :is-desktop="true"
                  :value="area"
                  :min="limitsArea[0]"
                  :max="limitsArea[1]"
                  @changeValue="changeAreaValue"
                  class="flat-params__slider"
                  v-if="filteredApartments && !showLoader"
                />
                <Slider
                  heading="Стоимость (млн)"
                  heading-margin-bottom="1rem"
                  :is-desktop="true"
                  :value="price"
                  :min="limitsPrice[0]"
                  :max="limitsPrice[1]"
                  @changeValue="changePriceValue"
                  class="flat-params__slider"
                  v-if="filteredApartments && !showLoader"
                />
              </div>
            </div>
            <Loader v-if="showLoader"/>
            <div class="flat-options js-flat-options" v-if="filteredApartments && !showLoader">
              <div class="flex items-center flat-options__heading flat-options-heading js-flats-heading">
                <span class="flat-options-heading__text" v-bind:class="{desc: orderBy === 'building_number' && sortOrder === 'desc', asc: orderBy === 'building_number' && sortOrder === 'asc' }" @click="sortBy('building_number')">Корпус</span>
                <span class="flat-options-heading__text" v-bind:class="{desc: orderBy === 'floor_number' && sortOrder === 'desc', asc: orderBy === 'floor_number' && sortOrder === 'asc' }" @click="sortBy('floor_number')">Этаж</span>
                <span class="flat-options-heading__text" v-bind:class="{desc: orderBy === 'bedrooms'  && sortOrder === 'desc', asc: orderBy === 'bedrooms'  && sortOrder === 'asc' }" @click="sortBy('bedrooms')">Комнаты</span>
                <span class="flat-options-heading__text" v-bind:class="{desc: orderBy === 'area'  && sortOrder === 'desc', asc: orderBy === 'area'  && sortOrder === 'asc' }" @click="sortBy('area')">Площадь</span>
                <span class="flat-options-heading__text" v-bind:class="{desc: orderBy === 'price'  && sortOrder === 'desc', asc: orderBy === 'price'  && sortOrder === 'asc' }" @click="sortBy('price')">Стоимость</span>
                <!-- <span class="flat-options-heading__text _uppercase _fw-800 _invisible _more">Подробнее</span> -->
                <span class="flat-options-heading__text _uppercase _fw-800 _invisible">Подробнее</span>
              </div>
              <router-link
                tag="div"
                :to="'/choice-of-apartment/selected/' + flat.id"
                class="flex items-end flat-options__row flat-options-row cursor-pointer"
                v-for="flat in filteredApartments"
                :key="flat.id"
              >
                <span class="flat-options-row__text _building">{{flat.building_number}}</span>
                <span class="flat-options-row__text _floor">{{flat.floor_number}}</span>
                <span class="flat-options-row__text _rooms">{{flat.bedrooms}}</span>
                <span class="flat-options-row__text _area">{{flat.area}} м<sup>2</sup></span>
                <span class="flat-options-row__text _price">{{flat.price.toString().indexOf('.') > -1 ? flat.price.split('.')[0] : flat.price}} руб.</span>
                <span class="flat-options-row__text _more">Подробнее</span>
<!--                <span class="flat-options-row__text _special" v-if="flat.special">акция</span>-->
<!--                <span class="flat-options-row__text _special" v-if="!flat.special"></span>-->
              </router-link>
            </div>
            <button class="scroll-to-top flex items-center justify-center cursor-pointer" type="button" @click="scrollToTop" v-if="isBottom">
              <svg>
                <use xlink:href="../../../images/sprite.svg#flat-arrow"/>
              </svg>
            </button>
          </div>
        </form>
        <!--          SCROLL TO TOP BTN -->
      </div>
    </div>
</template>
<script>
  import Picker from "../components/Picker";
  import Slider from "../components/Slider";
  import Loader from "../components/Loader"
  export default {
    components: {Slider, Picker, Loader},
    data() {
      return {
        isBottom: false,
        apartments: null,
        showParams: false,
        currentSort : 'area',
        selectedBuilding: [0,1,2,3],
        selectedRooms: [],
        showLoader: true,
        floor: [2, 21],
        area: [1, 200],
        price: [1,200],
        // floor: null,
        // area: null,
        // price: null,
        limitsFloor: [2, 21],
        limitsArea: [1, 200],
        limitsPrice: [1,200],
        // limitsFloor: null,
        // limitsArea: null,
        // limitsPrice: null,
        orderBy: 'area',
        sortOrder: 'asc',
        flatOptionsShown: false,
        buildingOptions: [
          {
            id: 0,
            name: 1,
            taken: false
          },
          {
            id: 1,
            name: 2,
            taken: false
          },
          {
            id: 2,
            name: 3,
            taken: false
          },
          {
            id: 3,
            name: 4,
            taken: false
          }
        ],
        roomOptions: [
          {
            id: 0,
            name: 1,
            taken: false
          },
          {
            id: 1,
            name: 2,
            taken: false
          },
          {
            id: 2,
            name: 3,
            taken: false
          },
          {
            id: 3,
            name: 4,
            taken: false
          }
        ],
      }
    },
    mounted() {
      axios.get('/apartments?status=available').then(response => {
        // this.apartments = response.data.data, this.showLoader = false,
        this.apartments = response.data.data
      }, this).then(
        () => {
          function getMinOfArray(numArray) {
            return Math.min.apply(null, numArray);
          }
          function getMaxOfArray(numArray) {
            return Math.max.apply(null, numArray);
          }
          function getExtrResult(array) {
            const arr = [];
            arr.push(getMinOfArray(array));
            arr.push(getMaxOfArray(array));
            return arr;
          }
          function getExtrRoundResult(array) {
            const arr = [];
            arr.push(Math.floor(getMinOfArray(array)));
            arr.push(Math.ceil(getMaxOfArray(array)));
            return arr;
          }
          let floorArr = [];
          let squareArr = [];
          let priceArr = [];
          this.apartments.forEach((item) => {
            floorArr.push(item.floor_number);
            squareArr.push(+item.area);
            priceArr.push((+item.price.replace(/\s/g, ''))/1000000);
          });
            this.floor = getExtrRoundResult(floorArr);
            this.limitsFloor = getExtrRoundResult(floorArr);
            this.area = getExtrRoundResult(squareArr);
            this.limitsArea = getExtrRoundResult(squareArr);
            this.price  = getExtrRoundResult(priceArr);
            this.limitsPrice = getExtrRoundResult(priceArr);
            this.showLoader = false;
        }
      )

    },
    methods: {
      attachHeader() {
        let flatsHeading = document.querySelector('.js-flats-heading');
        let flatOptions = document.querySelector('.js-flat-options');
        let fixedPosition = document.querySelector('.header').getBoundingClientRect().height;
        let positionY = flatOptions.getBoundingClientRect().y;
        if(positionY <= fixedPosition) {
          flatsHeading.classList.add('_fixed');
          flatOptions.style.paddingTop = fixedPosition - 5 + 'px';
          this.isBottom = true;
        } else {
          flatsHeading.classList.remove('_fixed');
          flatOptions.style.paddingTop = 0;
          this.isBottom = false;
        }
      },
      scrollToTop() {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      let flatsWrapper = document.querySelector('.js-flats-wrapper');
        flatsWrapper.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      },
      openParams() {
        this.showParams = !this.showParams;
        if (this.showParams) {
          this.flatOptionsShown = false;
        }
      },
      selectBuilding(option) {
        if (!option.taken) {
          this.selectedBuilding.indexOf(option.id) === -1 ? this.selectedBuilding.push(option.id): this.selectedBuilding.splice(this.selectedBuilding.indexOf(option.id),1)
        }
      },
      selectRooms(option) {
        if (!option.taken) {
          this.selectedRooms.indexOf(option.id) === -1 ? this.selectedRooms.push(option.id): this.selectedRooms.splice(this.selectedRooms.indexOf(option.id),1)
        }
      },
      changeFloorValue(floors) {
        this.floor = floors;
      },
      changeAreaValue(metres) {
        this.area = metres;
      },
      changePriceValue(price) {
        this.price = price;
      },
      showFlats() {
        this.flatOptionsShown = true;
      },
      sortBy(sortingName){
        this.showLoader = true
        switch (sortingName) {
          case 'building_number':
             if(this.sortOrder === 'asc'){
              sorting('building_number','desc',this)
            }else{
              sorting('building_number','asc',this)
            }
            break;
          case 'floor_number':
            if(this.sortOrder === 'asc'){
              sorting('floor_number','desc',this)
            }else{
              sorting('floor_number','asc',this)
            }
            break;
          case 'bedrooms':
            if(this.sortOrder === 'asc'){
              sorting('bedrooms','desc',this)
            }else{
              sorting('bedrooms','asc',this)
            }
            break;
          case 'area':
            if(this.sortOrder === 'asc'){
              sorting('area','desc',this)
            }else{
              sorting('area','asc',this)
            }
            break;
          case 'price':
            if(this.sortOrder === 'asc'){
              sorting('price','desc',this)
            }else{
              sorting('price','asc',this)
            }
            break;
        }

        function sorting(orderBy,sortOrder,ctx){
          ctx.showLoader = true
          ctx.filteredApartments.sort((a,b) => {
            let currentElement = typeof(a[orderBy]) === 'string' ? Number(a[orderBy].replace(/ /g,'')) : a[orderBy]
            let nextElement = typeof(b[orderBy]) === 'string' ? Number(b[orderBy].replace(/ /g,'')) : b[orderBy]
            if(sortOrder === 'desc'){
              if(currentElement < nextElement){
                return 1
              }
              if(currentElement > nextElement){
                return -1
              }
              return 0
            }else{
              if(currentElement > nextElement){
                return 1
              }
              if(currentElement < nextElement){
                return -1
              }
              return 0
            }
          })

          ctx.showLoader = false
          ctx.orderBy = orderBy
          ctx.sortOrder = ctx.sortOrder === 'asc' ? 'desc' : 'asc'
        }
      }
    },

    computed: {
      areaHeading() {
        return 'Площадь ' + '(м' + '<sup>' + 2 + '</sup>' + ')';
      },
      filteredApartments: {
        get: function() {
          if (!this.apartments) return null

          let filtered = [];
          this.apartments.filter(
            apartment => {
              if(!this.selectedRooms.length) {
                this.selectedRooms.push(...[0,1,2,3])
              }
              this.selectedRooms.forEach(room => {
                this.selectedBuilding.forEach((selectBuildingItem, index)=>{
                  if (
                    apartment.building_number === this.buildingOptions[selectBuildingItem].name
                    && apartment.bedrooms === this.roomOptions[room].name
                    && (apartment.floor_number >= this.floor[0] && apartment.floor_number <= this.floor[1])
                    && (apartment.area >= this.area[0] && apartment.area <= this.area[1])
                    && (apartment.price.replace(/ /g,'') >this.price[0] * 1000000 && apartment.price.replace(/ /g,'') < this.price[1] * 1000000)
                  ) {
                    filtered.push(apartment);
                  }
                })
              })
            }, this)

            filtered.sort((a,b) => {
              let currentElement = typeof(a[this.orderBy]) === 'string' ? Number(a[this.orderBy].replace(/ /g,'')) : a[this.orderBy]
              let nextElement = typeof(b[this.orderBy]) === 'string' ? Number(b[this.orderBy].replace(/ /g,'')) : b[this.orderBy]
              if(this.sortOrder === 'desc'){
                if(currentElement < nextElement){
                  return 1
                }
                if(currentElement > nextElement){
                  return -1
                }
                return 0
              }else{
                if(currentElement > nextElement){
                  return 1
                }
                if(currentElement < nextElement){
                  return -1
                }
                return 0
              }
            });
          return filtered;
        },
        set:function(newVal) {
          this.apartments = newVal
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  @import '../../../sass/variables';

  .scroll-to-top {
    position: absolute;
    left: 71.2rem;
    bottom: 4rem;
    width: 5.6rem;
    height: 5.6rem;

    border-radius: 50%;
    background: #ffffff;
    border: 1px solid $textAndBorder;

    outline: none;

    z-index: 100;

    & svg {
      fill: $textAndBorder;
      stroke: $textAndBorder;
      width: 1.2rem;
      height: 1.2rem;
      transform: rotate(-90deg);
    }
  }

  .component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .3s ease;
  }

  .component-fade-enter, .component-fade-leave-to
    /* .component-fade-leave-active до версии 2.1.8 */
  {
    opacity: 0;
  }

  .flat-choice {
    padding-top: 6rem;
    @media (min-width: $desktop-min-width) {
      padding-top: 8rem;
    }

    &-image {
      position: relative;

      &__pic {
        & img {
          height: 39rem;
          width: 100%;
        }
      }

      &__mask {
        position: absolute;

        width: 13.2rem;
        height: 22rem;

        bottom: 4.9rem;
        left: 10.4rem;

        opacity: 0.64;

        @media (min-width: $desktop-min-width) {
          bottom: 16.8rem;
          left: 86rem;
          width: 27.7rem;
          height: 46.3rem;

          & img {
            width: 27.7rem;
            height: 46.3rem;
          }

          &._third {
            bottom: 20.7rem;
            width: 23.4rem;
            height: 44.1rem;
            left: unset;
            right: 0;

            & img {
              width: 23.4rem;
              height: 44.1rem;
            }
          }
        }
      }
    }

    &__title {
      margin-left: 2.4rem;
      margin-bottom: 3.2rem;
      margin-top: 2rem;

      &._options-open {
        margin-bottom: 1.2rem;
      }
    }

    &__bg-desktop {
      background: url("/images/purchase/district-desktop.jpg");
      background-size: cover;
      background-repeat: no-repeat;
      background-position: right;
      background-attachment: fixed;
      position: relative;
    }

    @media (min-width: $desktop-min-width) {

      &__title {
        margin-left: 6.4rem;
      }
    }

    &__plan {
      padding: 1.7rem;
      width: 100%;

      font-size: 1.4rem;
      line-height: 1.6rem;
      letter-spacing: 0.16em;
      font-weight: 800;
      text-transform: uppercase;
      text-align: center;
      background: #FFF4E9;
      color: $hypertext;
      border: none;

      outline: none;

      &._options-open {
        order: 0;

        padding: 1.4rem 1.4rem 1.4rem 2.1rem;
        width: fit-content;
        margin-bottom: 2.4rem;
        margin-left: 2.4rem;

        font-size: 1.2rem;
        line-height: 1.5;
        background: $hypertext;
        color: #ffffff;
        border: none;


        outline: none;
      }
    }

    &__show {
      padding: 1.7rem;
      width: 100%;
      margin-bottom: 2.4rem;

      font-size: 1.4rem;
      letter-spacing: 0.16em;
      line-height: 1.5;
      font-weight: 800;
      text-align: center;
      text-transform: uppercase;
      border: none;
      color: $hypertext;

      background: #FFFBF8;

      outline: none;
      cursor: pointer;

      &._options-open {
        order: 2;
        margin-bottom: 0;
        margin-top: auto;
      }
    }

    &__options {
      padding-left: 1.6rem;
      padding-right: 1.6rem;
      background: #ffffff;
    }
  }

  .flat-choose {
    width: 100%;

    background: #ffffff;
    border: none;
    outline: none;

    &._options-open {
      order: 1;
    }

    &__text {
      margin-right: 0.8rem;
      padding: 1.7rem;

      font-size: 1.4rem;
      line-height: 1.6rem;
      font-weight: 800;
      text-transform: uppercase;

      cursor: pointer;
    }

    &__icon {
      width: 1.6rem;
      height: 1.6rem;

      &._arrow {
        width: 1.7rem;
        height: 1.7rem;
      }

      &._minus {
        height: 0.2rem;
      }
    }
  }

  .flat-params {
    padding: 2rem 2.4rem 3.2rem;
    background: #ffffff;
    order: 2;

    &__row {
      margin-bottom: 1.6rem;
    }

    @media (min-width: $desktop-min-width) {
      padding: 0;
      background: transparent;

      &__wrapper {
        padding: 6.1rem 6.4rem 8.3rem;
        background: rgba(255, 251, 248, 0.88);
        width: 74rem;
        height: calc(100vh - 8rem);
        overflow: auto;
      }

      &__subtitle {
        position: relative;
        margin-top: 1.6rem;
        margin-bottom: 2.4rem;

        text-transform: uppercase;
        letter-spacing: 0.16em;
        font-weight: 800;
        line-height: 1.5;
        border: none;
      }

      &__row {
        margin-bottom: 2.7rem;

        &._second {
          margin-bottom: 5.1rem;
        }
      }

      &__pickers {
        margin-right: 3.4rem;
        margin-bottom: 2.4rem;

        &:last-child {
          margin-bottom: 0;
        }
      }

      &__picker {
        width: 25.2rem;
        margin-bottom: 3.2rem;

        &:last-child {
          margin-bottom: 0;
        }
      }

      &__slider {
        width: 32.7rem;
        margin-bottom: 2.3rem;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .flat-options {
    height: 29rem;
    overflow: auto;

    font-size: 1.1rem;
    line-height: 1.5;
    font-weight: 800;
    color: $textAndBorder;

    @media (min-width: $desktop-min-width) {
      height: unset;
      font-size: 1.4rem;
    }

    &._options-open {
      order: 4;
    }

    &-heading {
      font-weight: 400;
      padding-bottom: 1.4rem;
      padding-top: 3.6rem;
      position: sticky;
      top: -0.2rem;
      background: #ffffff;
      border-bottom: 0.1rem solid #C6C6C6;

      &__text{
        cursor: pointer;
        &.desc{
          position: relative;
          &::after{
            content: '';
            position: absolute;
            left: 100%;
            top: 50%;
            width: 0;
            height: 0;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-top: 5px solid #000;
            clear: both;
            margin-top: -2px;
            margin-left: 4px;
          }
        }

        &.asc{
          position: relative;
          &::after{
            content: '';
            position: absolute;
            left: 100%;
            top: 50%;
            width: 0;
            height: 0;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-bottom: 5px solid #000;
            clear: both;
            margin-top: -2px;
            margin-left: 4px;
          }
        }
      }

      @media (min-width: $desktop-min-width) {
        background: transparent;

        &._fixed {
          position: fixed;
          top: 8rem;
          left: 0;
          border-bottom: none;
          width: 74rem;
          padding-left: 6.4rem;
          padding-right: 6.4rem;
          background: linear-gradient(to right, #fef9f6,#f7f6f5);

          &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 6.4rem;
            height: 0.1rem;
            width: 61.2rem;

            background: #C6C6C6;
          }
        }
      }
    }
  }
</style>
